// Skiplukk (vinnsel, 27.10): en ordre med type «skiplukk» der kunden trenger hjelp til å finne
// riktige ski, primært langrenn. Brukes av CreateOrder, OrderList og OrderDetails. Feltene og
// vaskingen på serveren: src/model/Order.js og rensSkiplukk i server.js.

export const BRUK = [
  { verdi: 'klassisk', tittel: 'Klassisk' },
  { verdi: 'skoyting', tittel: 'Skøyting' },
  { verdi: 'tur', tittel: 'Tur / fjellski' },
  { verdi: 'fell', tittel: 'Fellski' },
  { verdi: 'usikker', tittel: 'Vet ikke' },
];

export const NIVA = [
  { verdi: 'mosjon', tittel: 'Mosjon / tur' },
  { verdi: 'trening', tittel: 'Trener jevnlig' },
  { verdi: 'konkurranse', tittel: 'Konkurranse' },
];

export const MAKS_PAR = 6; // som MAKS_PRODUKTER i ski-bestillingen på nettsiden

export const tomtPar = () => ({ hvem: '', merke: '', produkt: '', bruk: '', niva: '', vekt: '', hoyde: '', lengde: '', budsjett: '', grunnprepp: false });

export const erSkiplukk = (ordre) => ordre?.type === 'skiplukk';

const tittelFor = (liste, verdi) => liste.find((x) => x.verdi === verdi)?.tittel || '';

// «Kona: Klassisk, 62 kg, 168 cm»
export function parTekst(p) {
  const deler = [
    [p?.merke, p?.produkt].filter(Boolean).join(' '),
    tittelFor(BRUK, p?.bruk),
    tittelFor(NIVA, p?.niva).toLowerCase(),
    p?.vekt && `${p.vekt} kg`,
    p?.hoyde && `${p.hoyde} cm`,
    p?.lengde && `lengde ${p.lengde}`,
    p?.grunnprepp && 'grunnprepp',
  ].filter(Boolean);
  const tekst = deler.join(', ') || 'Ikke fylt ut';
  return p?.hvem ? `${p.hvem}: ${tekst}` : tekst;
}

export const antallPar = (ordre) => (ordre?.skiplukk?.par || []).length;

// Overskrift i lister: «Skiplukk, 2 par» eller «Skiplukk: Klassisk, 75 kg …»
export function skiplukkTittel(ordre) {
  const par = ordre?.skiplukk?.par || [];
  if (par.length > 1) return `Skiplukk, ${par.length} par`;
  if (par.length === 1) return `Skiplukk: ${parTekst(par[0])}`;
  return 'Skiplukk';
}

// Det skjemaet sender: tall som tekst gjøres om på serveren.
export const tilLagring = (par) => ({ par: par.map((p) => ({ ...p })) });

export const fraOrdre = (ordre) => {
  const par = ordre?.skiplukk?.par || [];
  return par.length
    ? par.map((p) => ({ ...tomtPar(), ...p, vekt: p.vekt ?? '', hoyde: p.hoyde ?? '', grunnprepp: Boolean(p.grunnprepp) }))
    : [tomtPar()];
};

// Skiservice i butikkmodus på nettsiden (som «Registrer service»). `par` og `grunnprepp` får
// ski-bestillingen til å lage ett produkt per par og forhåndsvelge «Grunnprepp nye ski» (Hygraph)
// på de parene kunden vil ha grunnprepp på (royken-sykkelservice src/pages/ski-skoyte/index.astro).
export function skiserviceSti(par = []) {
  const antall = Math.min(Math.max(par.length, 1), MAKS_PAR);
  const med = par.slice(0, MAKS_PAR).map((p, i) => (p.grunnprepp ? i + 1 : null)).filter(Boolean);
  // Merket per par fyller merkefeltet i bestillingen («|» mellom parene). Ved flere par med
  // «– hvem», som bestillingen selv ber om når merkene er like («Fischer – mamma»).
  const merker = par.slice(0, MAKS_PAR).map((p) => {
    const merke = String(p.merke || '').trim();
    const hvem = String(p.hvem || '').trim();
    return (par.length > 1 && merke && hvem ? `${merke} – ${hvem}` : merke).replace(/\|/g, ' ').slice(0, 60);
  });
  return `/ski-skoyte?kat=ski&par=${antall}${med.length ? `&grunnprepp=${med.join(',')}` : ''}${
    merker.some(Boolean) ? `&merke=${encodeURIComponent(merker.join('|'))}` : ''
  }`;
}

// Det som må være fylt ut på hvert par (vinnsel, 27.10): merke, vekt og høyde, i tillegg til bruk.
export function manglerFelt(par = []) {
  for (let i = 0; i < par.length; i++) {
    const p = par[i];
    const navn = par.length > 1 ? `par ${i + 1}` : 'skiene';
    if (!p.bruk) return `Velg bruk for ${navn}.`;
    if (!String(p.merke || '').trim()) return `Fyll inn merke for ${navn}.`;
    if (!String(p.vekt ?? '').toString().trim()) return `Fyll inn vekt for ${navn}.`;
    if (!String(p.hoyde ?? '').toString().trim()) return `Fyll inn høyde for ${navn}.`;
  }
  return '';
}

// Oppfølgeren er varslet ved innlogging til skiplukket er åpnet (NyeSkiplukk.jsx).
export const erNyttForOppfolger = (ordre, ansatt) =>
  erSkiplukk(ordre) && Boolean(ansatt) && ordre.Oppfolger === ansatt && ordre.Ansatt !== ansatt && !ordre.oppfolgerSett;
